module.exports = __webpack_public_path__ + "static/media/corporate-services-img56.130f4537.jpg";